<template>
  <aside
    ref="sidebarContainer"
    class="flex h-auto flex-col overscroll-contain"
    data-testid="mobile-sidebar"
  >
    <div class="sticky top-0 z-10 bg-white">
      <SFHeaderTopNavigation
        v-if="currentMenu"
        :current-homepage="currentMenu"
      />
    </div>
    <div class="flex grow flex-col">
      <template v-if="!currentMenu">
        <SFMobileGenderNavigation />
      </template>
      <template v-else>
        <SFMobileNavigationSkeleton
          v-if="!navigationItems || navigationItems.length === 0"
          :navigation-item="navigationItems"
        />
        <SFMobileNavigation
          v-else
          :is-open="isOpen"
          :navigation-items="navigationItems"
          @click-link="$emit('close')"
          @scroll-to-top="scrollToTop"
        />
      </template>
    </div>
  </aside>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import type { NavigationItems } from '@scayle/storefront-nuxt'
import SFMobileNavigation from './navigation/SFMobileNavigation.vue'
import SFHeaderTopNavigation from './navigation/SFHeaderTopNavigation.vue'
import SFMobileNavigationSkeleton from './navigation/SFMobileNavigationSkeleton.vue'
import SFMobileGenderNavigation from './navigation/SFMobileGenderNavigation.vue'
import { onBeforeRouteLeave } from '#app/composables/router'
import { useTopNavigationMenu } from '~/composables/useTopNavigationMenu'

const { isOpen, navigationItems } = defineProps<{
  isOpen: boolean | undefined
  navigationItems?: NavigationItems
}>()

defineEmits<{
  close: []
}>()

const sidebarContainer = ref<HTMLElement | null>(null)

const { currentMenu } = useTopNavigationMenu()

const scrollToTop = () => {
  sidebarContainer.value?.scrollTo({ top: 0, behavior: 'smooth' })
}

// Whenever the route changes, we want to make sure that the mobile sidebar is closed.
onBeforeRouteLeave((_to, _from, next) => {
  // emit('close')
  next()
})

defineOptions({
  name: 'SFMobileSidebar',
})
</script>
